import React from "react";
import { Link } from "react-router-dom";
export default class About extends React.Component 
{
    render()
     {
        return<> 
    
    <div className="container-fluid bg-primary py-5 mb-5">
        <div className="container py-5">
            <div className="row align-items-center py-4">
                <div className="col-md-6 text-center text-md-left">
                    <h1 className="display-4 mb-4 mb-md-0 text-secondary text-uppercase">About</h1>
                </div>
                <div className="col-md-6 text-center text-md-right">
                    <div className="d-inline-flex align-items-center">
                        <Link className="btn btn-sm btn-outline-light" to="/">Home</Link>
                        <i className="fas fa-angle-double-right text-light mx-2"></i>
                        <Link className="btn btn-sm btn-outline-light disabled" to="">About</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* About Start */}
    <div className="container-fluid py-5 mb-5">
        <div className="container">
            <div className="row">
                <div className="col-lg-5">
                    <div className="d-flex flex-column align-items-center justify-content-center bg-about rounded h-100 py-5 px-3">
                        <i className="fa fa-5x fa-award text-primary mb-4"></i>
                        <h1 className="display-2 text-white mb-2" data-toggle="counter-up">25</h1>
                        <h2 className="text-white m-0">Years Experience</h2>
                    </div>
                </div>
                <div className="col-lg-7 pt-5 pb-lg-5">
                    <h6 className="text-secondary font-weight-semi-bold text-uppercase mb-3">Learn About Us</h6>
                    <h1 className="mb-4 section-title">We Provide The Best Cleaning Services</h1>
                    <h5 className="text-muted font-weight-normal mb-3">Eos kasd eos dolor vero vero, lorem stet diam rebum. Ipsum amet sed vero dolor sea lorem justo est dolor eos</h5>
                    <p>Invidunt lorem justo sanctus clita. Erat lorem labore ea, justo dolor lorem ipsum ut sed eos, ipsum et dolor kasd sit ea justo. Erat justo sed sed diam. Ea et erat ut sed diam sea ipsum est dolor</p>
                    <div className="d-flex align-items-center pt-4">
                        <Link to="/Contact" className="btn btn-primary mr-5">Learn More</Link>
                        <button type="button" className="btn-play" data-toggle="modal"
                            data-src="https://www.youtube.com/embed/DWRcNpR6Kdc" data-target="#videoModal">
                            <span></span>
                        </button>
                        <h5 className="font-weight-normal text-white m-0 ml-4 d-none d-sm-block">Play Video</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* About End */}


    {/* Video Modal Start */}
    <div className="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-body">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>        
                    {/* 16:9 aspect ratio */}
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe className="embed-responsive-item" src="" id="video"  allowscriptaccess="always" allow="autoplay"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* Video Modal End */}


    {/* Features Start */}
    <div className="container-fluid bg-light py-5">
        <div className="container py-5">
            <div className="row">
                <div className="col-lg-7 pt-lg-5 pb-3">
                    <h6 className="text-secondary font-weight-semi-bold text-uppercase mb-3">Why Choose Us</h6>
                    <h1 className="mb-4 section-title">25 Years Experience In Cleaning Industry</h1>
                    <p className="mb-4">Dolores lorem lorem ipsum sit et ipsum. Sadip sea amet diam dolore sed et. Sit rebum labore sit sit ut vero no sit. Et elitr stet dolor sed sit et sed ipsum et kasd ut. Erat duo eos et erat sed diam duo</p>
                    <div className="row">
                        <div className="col-sm-4">
                            <h1 className="text-secondary mb-2" data-toggle="counter-up">225</h1>
                            <h6 className="font-weight-semi-bold mb-sm-4">Our Cleaners</h6>
                        </div>
                        <div className="col-sm-4">
                            <h1 className="text-secondary mb-2" data-toggle="counter-up">1050</h1>
                            <h6 className="font-weight-semi-bold mb-sm-4">Happy Clients</h6>
                        </div>
                        <div className="col-sm-4">
                            <h1 className="text-secondary mb-2" data-toggle="counter-up">2500</h1>
                            <h6 className="font-weight-semi-bold mb-sm-4">Projects Done</h6>
                        </div>
                    </div>
                </div>
                <div className="col-lg-5" style={{mineight: "400px"}}>
                    <div className="position-relative h-100 rounded overflow-hidden">
                        <img className="position-absolute w-100 h-100" src="img/feature.jpg" style={{objectfit: "cover"}}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* Features End */}


    {/* Team Start */}
    <div className="container-fluid pt-5">
        <div className="container py-5">
            <div className="row align-items-end mb-4">
                <div className="col-lg-5">
                    {/* <h6 className="text-secondary font-weight-semi-bold text-uppercase mb-3">Meet Our Team</h6> */}
                    <h1 className="section-title mb-5">Meet Our Team</h1>
                </div>
                <div className="col-lg-6">
                    <h4 className="font-weight-normal text-muted mb-3">"Get to know the faces behind our work! Meet our talented and dedicated team, committed to providing the best possible service. our team's collaborative and supportive approach creates a positive and productive work environment that is sure to lead to great success."</h4>
                </div>
            </div>
        </div>
    </div>

    {/* Team End */}
    <div class="container-xxl pt-5 pb-3">
            <div class="container">
             
                <div class="row g-4">
                    <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                        <div class="team-item text-center rounded overflow-hidden">
                            <div class="rounded-circle overflow-hidden m-4">
                                <img class="img-fluid" src="img/team-1.jpg" alt=""/>
                            </div>
                            <h5 class="mb-0">CHETAN KUMAYU</h5>
                           
                            <div class="d-flex justify-content-center mt-3">
                                <a class="btn btn-square btn-primary mx-1" href="
                                https://www.linkedin.com/in/%F0%9D%99%B2%F0%9D%99%B7%F0%9D%99%B4%F0%9D%9A%83%F0%9D%99%B0%F0%9D%99%BD-%F0%9D%9A%94%F0%9D%9A%9E%F0%9D%9A%96%F0%9D%9A%8A%F0%9D%9A%A2%F0%9D%9A%9E-79b74724a"><i class="fa-linkedin-in"></i></a>
                                <a class="btn btn-square btn-primary mx-1" href="https://twitter.com/chetan_kumayu?t=37XDQMfRsc-AQ0Eh0Gx7YA&s=09"><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-primary mx-1" href="https://instagram.com/24_chetan_kumayu?igshid=YmMyMTA2M2Y="><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                        <div class="team-item text-center rounded overflow-hidden">
                            <div class="rounded-circle overflow-hidden m-4">
                                <img class="img-fluid" src="img/team-2.jpg" alt=""/>
                            </div>
                            <h5 class="mb-0">DILISHA VERMA</h5>
                           
                            <div class="d-flex justify-content-center mt-3">
                                <a class="btn btn-square btn-primary mx-1" href="
                                https://www.linkedin.com/in/%F0%9D%99%B2%F0%9D%99%B7%F0%9D%99%B4%F0%9D%9A%83%F0%9D%99%B0%F0%9D%99%BD-%F0%9D%9A%94%F0%9D%9A%9E%F0%9D%9A%96%F0%9D%9A%8A%F0%9D%9A%A2%F0%9D%9A%9E-79b74724a"><i class="fa-linkedin-in"></i></a>
                                <a class="btn btn-square btn-primary mx-1" href="https://twitter.com/chetan_kumayu?t=37XDQMfRsc-AQ0Eh0Gx7YA&s=09"><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-primary mx-1" href="https://instagram.com/24_chetan_kumayu?igshid=YmMyMTA2M2Y="><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                        <div class="team-item text-center rounded overflow-hidden">
                            <div class="rounded-circle overflow-hidden m-4">
                                <img class="img-fluid" src="img/team-3.jpg" alt=""/>
                            </div>
                            <h5 class="mb-0">AKSHAY MAHAJAN</h5>
                           
                            <div class="d-flex justify-content-center mt-3">
                                <a class="btn btn-square btn-primary mx-1" href="
                                https://www.linkedin.com/in/%F0%9D%99%B2%F0%9D%99%B7%F0%9D%99%B4%F0%9D%9A%83%F0%9D%99%B0%F0%9D%99%BD-%F0%9D%9A%94%F0%9D%9A%9E%F0%9D%9A%96%F0%9D%9A%8A%F0%9D%9A%A2%F0%9D%9A%9E-79b74724a"><i class="fa-linkedin-in"></i></a>
                                <a class="btn btn-square btn-primary mx-1" href="https://twitter.com/chetan_kumayu?t=37XDQMfRsc-AQ0Eh0Gx7YA&s=09"><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-primary mx-1" href="https://instagram.com/24_chetan_kumayu?igshid=YmMyMTA2M2Y="><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                   
                    <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                        <div class="team-item text-center rounded overflow-hidden">
                            
                        </div>
                    </div>
            </div>
            </div>
            </div>
        </>
            
    }
}